import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import {useStore} from "../../../app/stores/rootStore";
export default observer(function ProductSearch() {
    const { searchStore, productsStore } = useStore();
    const navigate = useNavigate();

    const handleSearchClick = () => {
        if (searchStore.selectedItem?.id) {
            navigate(`/product/${searchStore.selectedItem.id}`);
            searchStore.isLoaded = false; // Close dropdown
        }
    };

    return (
        <section className="cid-uAXw0YQ0CC1 bg-light border-bottom" style={{ marginTop: '104px' }}>
            <div className="container-fluid p-0">
                <div className="row g-0">
                    <div className="col-12 position-relative">
                        <div className="input-group input-group-lg">
                            {/* Main Input */}
                            <input 
                                type="text" 
                                className="form-control border-0 rounded-0 ps-4" 
                                style={{ height: '70px', fontSize: '1.25rem' }}
                                placeholder="What are you looking for?" 
                                value={searchStore.query}
                                onChange={(e) => searchStore.setQuery(e.target.value, productsStore.products)}
                                onFocus={() => searchStore.query && (searchStore.isLoaded = true)}
                            />

                            {/* CANCEL SELECTION OPTION: Visible only when there is a query */}
                            {searchStore.query && (
                                <button 
                                    className="btn btn-white border-0 rounded-0 px-3 text-muted" 
                                    type="button"
                                    onClick={() => searchStore.clearSearch()}
                                    style={{ backgroundColor: '#fff', zIndex: 5 }}
                                >
                                    <i className="bi bi-x-lg fs-5">Clear</i>
                                </button>
                            )}

                            {/* SEARCH BUTTON */}
                            <button 
                                className="btn btn-primary rounded-0 px-5" 
                                type="button" 
                                onClick={handleSearchClick}
                                disabled={!searchStore.selectedItem}
                            >
                                <i className="bi bi-search fs-4"> Search</i>
                            </button>
                        </div>

                        {/* Autocomplete Dropdown */}
                        {searchStore.isLoaded && searchStore.items.length > 0 && (
                            <ul className="list-group position-absolute w-100 shadow rounded-0 border-0 overflow-hidden" 
                                style={{ zIndex: 1050, top: '100%' }}>
                                {searchStore.items.map(p => (
                                    <li 
                                        key={p.id} 
                                        className={`list-group-item list-group-item-action py-3 border-start-0 border-end-0 ${searchStore.selectedItem?.id === p.id ? 'active' : ''}`}
                                        onClick={() => searchStore.selectSuggestion(p)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="d-flex align-items-center justify-content-between ps-3">
                                            <div className="d-flex align-items-center">
                                                {p.displayMode === 'video' ? (<video controls autoPlay={true} loop muted style={{ width: '45px', height: '45px', objectFit: 'cover' }}>
                                                    <source src={p.mainImageUrl} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>) :
                                                (<img 
                                                    src={p.mainImageUrl} 
                                                    alt={p.title} 
                                                    className="rounded me-3" 
                                                    style={{ width: '45px', height: '45px', objectFit: 'cover' }} 
                                                />)}
                                                <div>
                                                    <div className="fw-bold">{p.title}</div>
                                                    <small className={searchStore.selectedItem?.id === p.id ? "text-white-50" : "text-muted"}>
                                                        Rs. {p.productPrice?.toLocaleString()}
                                                    </small>
                                                </div>
                                            </div>

                                            {/* PHOTO/VIDEO TAG SELECTION */}
                                            <div className="pe-3">
                                                {p.displayMode === 'video' ? (
                                                    <span className="badge rounded-pill bg-danger">
                                                        <i className="bi bi-play-circle me-1"></i> Video
                                                    </span>
                                                ) : (
                                                    <span className="badge rounded-pill bg-info text-dark">
                                                        <i className="bi bi-camera me-1"></i> Photo
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
});